/** Frontend gate for experimental Robinhood ecosystem UI. Default false.

Build-time: REACT_APP_ROBINHOOD_ECOSYSTEM_ENABLED (CRA bake-in).
Runtime: /api/config robinhood_ecosystem.enabled (backend authoritative).

Either may enable the surface; both false → hidden. Backend still 404s if disabled.
*/

export function robinhoodEcosystemEnabledFromEnv() {
  const raw = (process.env.REACT_APP_ROBINHOOD_ECOSYSTEM_ENABLED || "").trim().toLowerCase();
  return raw === "1" || raw === "true" || raw === "yes" || raw === "on";
}

/** @deprecated prefer isRobinhoodEcosystemEnabled(config) for UI gates */
export const ROBINHOOD_ECOSYSTEM_ENABLED = robinhoodEcosystemEnabledFromEnv();

export function isRobinhoodEcosystemEnabled(config) {
  if (robinhoodEcosystemEnabledFromEnv()) return true;
  return Boolean(config?.robinhood_ecosystem?.enabled);
}
